import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const login = async (email, password, isRegisterMode = false, name = "") => {
    setIsLoading(true);

    try {
      // Имитация запроса к API
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (isRegisterMode) {
        // Логика регистрации
        console.log(`Регистрация нового пользователя: ${name}, ${email}`);
        // Здесь можно добавить реальный запрос к API для регистрации
      } else {
        // Логика входа
        console.log(`Вход пользователя: ${email}`);
      }

      // Сохраняем данные пользователя
      setUser({
        email,
        name: isRegisterMode ? name : "Пользователь", // Или другое значение по умолчанию
        isAuthenticated: true,
      });

      setShowLogin(false);
    } catch (error) {
      console.error("Ошибка авторизации:", error);
      // Можно добавить обработку ошибок (например, показать сообщение пользователю)
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        showLogin,
        setShowLogin,
        login,
        logout,
        isLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
